import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header'
import { Button } from '@arnsbogroup/react-voicearchive'

const QualityCheckWidget = ({widget}) => {
  const mounted = useRef(false)
  
  const [checks, setChecks] = useState([])
  const [showCheckFiles, setShowCheckFiles] = useState([])
  const [fileErrors, setFileErrors] = useState([])
  const [title, setTitle] = useState('')

  useEffect(() => {
    mounted.current = true
    fetch(`supplierdashboard/${widget.widgetId}`)
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setChecks(data.data.checks)
      }
    })

    setTitle(widget.widgetId.replace(/_/g, ' '))

    return () => {
      mounted.current = false
    }
  }, [])

  const showFiles = (uid) => {
    if (showCheckFiles.includes(uid)) {
      setShowCheckFiles(showCheckFiles.filter((supplierId) => supplierId !== uid));
    } else {
      setShowCheckFiles([...showCheckFiles, uid]);
    }
  }

  const setAutoDeliveryRating = (supplierId, rating) => {
    const data = new URLSearchParams();
    data.append('table', 'supplier');
    data.append('field', 'autoDeliveryRating');
    data.append('rowid', supplierId);
    data.append('val', rating);

    fetch('/update/field', {
      method: 'POST',
      body: data
    })
    .then(() => {
      setChecks(checks.filter((check) => check.uid != supplierId))
    })
  }
  
  const getAudioError = (errorCode, fileId) => {
    var audioError = ''
    switch(errorCode) {
      case 1:
        audioError = "Fetching process aborted by user."
        break
      case 2:
        audioError = "Error occurred when downloading."
        break
      case 3:
        audioError = "Error occurred when decoding."
        break
      case 4:
        audioError = "Audio not supported."
        break
      default:
        return
    }

    setFileErrors([...fileErrors, { fileId: fileId, error: audioError + ' Please download the file.'}])
  }
  
  const widget_id = `ID_${widget.widgetId}`
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />
      <div className="w-full text-xs">
          <p className="border-b p-4">
              Click each voice talent to playback their latest recordings, and approve or reject.
          </p>
          { !checks.length ? (
            <p className="p-4 text-gray-400 text-center">
              No pending quality checks.
            </p>
          ) : (
            <>
              {checks.map((check) => (
                <div className="border-b">
                  <div className="border-b">
                    <div
                      className="flex justify-end items-center hover:bg-gray-200 space-x-2 px-4 py-2"
                      onClick={() => showFiles(check.uid)}
                    >
                      <span className="grow truncate cursor-pointer">
                          {check.userid}
                      </span>

                      <span>
                          {check.jobs} completed jobs
                      </span>

                      <Button
                        size="xs"
                        onClick={() => setAutoDeliveryRating(check.uid, 1)}
                        variant="outline"
                        state="negative"
                      >
                        Reject
                      </Button>

                      <Button
                        size="xs"
                        onClick={() => setAutoDeliveryRating(check.uid, 5)}
                      >
                        Approve
                      </Button>
                    </div>
                    {showCheckFiles.includes(check.uid) &&
                      <div className="files">
                        {check.files.map((file) => (
                          <div className="flex justify-between items-center p-4">
                            <a href={file.url} target="_blank" className="truncate underline text-primary">
                              {file.title}
                            </a>
                            <div className="grow">
                              <audio
                                onError={(e) => getAudioError(e.currentTarget.error.code, file.uid)}
                                controls
                                controlsList="nodownload"
                                src={file.url}
                              >
                                Your browser does not support the audio element. Please download and listen on an external player.
                              </audio>
                              { fileErrors.map((errors) => {
                                  if (errors.fileId == file.uid) {
                                    return <span className="text-negative">{errors.error}</span>
                                  }
                                })
                              }
                            </div>
                          </div>
                        ))}
                      </div>
                    }
                </div>
                </div>
              ))}
            </>
          )
        }
      </div>
    </li>
  )

}

export default QualityCheckWidget
